import { IOptionProps } from '@amobee/component-library';
import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl } from '@angular/forms';
import { AdditionalCostDTO } from 'src/app/planner/dto/AdditionalCostDTO';
import { AdvertiserInfoVO } from 'src/app/planner/interfaces/AdvertiserInfo';
import { DigitalTacticVO } from 'src/app/planner/interfaces/vo/DigitalTacticVO';
import { IdNameVO } from 'src/app/planner/interfaces/vo/IdNameVO';
import { BudgetingService } from 'src/app/planner/services/budgeting.service';
import { DataService } from 'src/app/planner/services/data.service';
import { ThirdPartyCostPaidBy } from '../../planner-edit/constants/ThirdPartyCostPaidBy.const';
import { ThirdPartyCostType } from '../../planner-edit/constants/ThirdPartyCostType.const';

@Component({
  selector: 'third-party-cost',
  templateUrl: './third-party-cost.component.html',
  styleUrls: ['./third-party-cost.component.scss']
})
export class ThirdPartyCostComponent implements OnInit {

  @Input() group: string;
  @Input() formArray: FormArray;
  @Input() advertiserInfo: AdvertiserInfoVO;
  @Input() tacticsVO: DigitalTacticVO;
  currencySymbol: string;
  // Paid By Data
  thirdPartyCostPaidBy = ThirdPartyCostPaidBy;
  initialThirdPartyCostPaidBy: IOptionProps[] = [];
  // Cost Type Data
  thirdPartyCostType = ThirdPartyCostType;
  initialThirdPartyCostType: IOptionProps[] = [];
  // TPA Platform Data
  tpaPlatforms: Array<IdNameVO> = [];
  filteredTpaPlatform: Array<Array<IdNameVO>> = [];
  initialTpaPlatform: IdNameVO[] = [];

  constructor(
    private fb: FormBuilder,
    private budgetingService: BudgetingService,
    private dataService: DataService
  ) { }

  ngOnInit() {
    this.dataService.getTpaPlatforms().then((response: IdNameVO[]) => {
      response.sort((a, b) => {
        let aName = a.name.toLowerCase(), bName = b.name.toLowerCase();
        if (aName < bName) {
          return -1;
        }
        if (aName > bName) {
          return 1;
        }
        return 0;
      });
      this.tpaPlatforms = response;
      if (this.tacticsVO && this.tacticsVO.thirdPartyCost) {
        let isPreviouslyDisabled = this.formArray.disabled;
        for (let acvo of this.tacticsVO.thirdPartyCost) {
          this.thirdPartyCost.push(new AdditionalCostDTO(this.fb).formGroup);
          this.initialThirdPartyCostPaidBy.push({ label: this.getLabelByValue(acvo.paidById, 'paidById'), value: acvo.paidById + '' });
          this.initialThirdPartyCostType.push({ label: this.getLabelByValue(acvo.costTypeId, 'costTypeId'), value: acvo.costTypeId + '' });
          this.initialTpaPlatform.push(this.tpaPlatforms.find((v) => v.id === acvo.vendorId));
        }
        this.thirdPartyCost.patchValue(this.tacticsVO.thirdPartyCost);
        this.thirdPartyCost.markAllAsTouched();
        if (isPreviouslyDisabled) {
          this.thirdPartyCost.disable();
        }
      }
    });
    if (this.advertiserInfo.currency) {
      this.currencySymbol = this.budgetingService.getCurrencyAbbrevWithSymbol(this.advertiserInfo.currency);
    }
  }

  addThirdPartyCost() {
    if (!this.isDisabled) {
      let newTpcDto = new AdditionalCostDTO(this.fb).formGroup;
      this.thirdPartyCost.push(newTpcDto);
      this.initialThirdPartyCostPaidBy.push({ label: this.getLabelByValue(newTpcDto.get('paidById').value, 'paidById'), value: newTpcDto.get('paidById').value + '' });
      this.thirdPartyCost.markAllAsTouched();
    }
  }

  resetThirdPartyCost() {
    if (!this.isDisabled) {
      this.thirdPartyCost.clear();
      this.initialThirdPartyCostPaidBy = [];
      this.initialThirdPartyCostType = [];
      this.initialTpaPlatform = [];
      this.filteredTpaPlatform = [];
    }
  }

  removeThirdPartyCost(index: number) {
    if (!this.isDisabled) {
      this.thirdPartyCost.removeAt(index);
      this.initialThirdPartyCostPaidBy.splice(index, 1);
      this.initialThirdPartyCostType.splice(index, 1);
      this.initialTpaPlatform.splice(index, 1);
      this.filteredTpaPlatform.splice(index, 1);
    }
  }

  costTypeChange($event: IOptionProps, index: number) {
    this.costTypeId(index).patchValue($event.value);
  }


  vendorChange($event: IdNameVO, index: number) {
    this.vendorId(index).patchValue($event && $event.id);
  }

  filterVendor(searchString: string, index: number) {
    let results;
    if (searchString) {
      let lowerCaseStr = searchString.toLowerCase();
      results = this.tpaPlatforms.filter((t) => {
        return t.name.toLowerCase().includes(lowerCaseStr);
      });
    } else {
      results = this.tpaPlatforms;
    }
    setTimeout(() => {
      this.filteredTpaPlatform[index] = results;
    });
  }

  paidByChange($event: IOptionProps, index: number) {
    this.paidById(index).patchValue($event.value);
  }

  getLabelByValue(id: number, field: 'costTypeId' | 'paidById') {
    let checkObj = field === 'costTypeId' ? Object.values(this.thirdPartyCostType) : Object.values(this.thirdPartyCostPaidBy);
    for (let obj of checkObj) {
      if (obj.id == id) {
        return obj.label;
      }
    }
    return undefined;
  }

  get thirdPartyCost(): FormArray {
    return <FormArray>this.formArray.controls[this.group].get('thirdPartyCost');
  }

  get isDisabled(): boolean {
    return this.thirdPartyCost.disabled;
  }

  costTypeId(index: number): FormControl {
    return this.thirdPartyCost.controls[index].get('costTypeId') as FormControl;
  }

  vendorId(index: number): FormControl {
    return this.thirdPartyCost.controls[index].get('vendorId') as FormControl;
  }

  cPMCost(index: number): FormControl {
    return this.thirdPartyCost.controls[index].get('cPMCost') as FormControl;
  }

  paidById(index: number): FormControl {
    return this.thirdPartyCost.controls[index].get('paidById') as FormControl;
  }

}
